export const APP_NAME = "PS Promoter Panel";

export const DEVICE_TYPE = "web";
export const IMEI = "5dcd4d1c2aa4408e";
export const FIREBASE_TOKEN = "AAAAAA2222111";
export const DEVICE_LANGUAGE = "en";

export const ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  EVENTS: "/events",
  EVENT_DETAILS: "/events/:id",
  UPLOAD: "/upload",
  GALLERY: "/gallery",
};
